import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_mtacardmanager } from "../shared/data.service";

import { wsMTACardShipmentSchoolReceiveDataInfo } from "../shared/wsMTACardShipmentSchoolReceiveDataInfo";
import { wsMTACardShipmentSchoolReceiveStatusInfo } from "../shared/wsMTACardShipmentSchoolReceiveDataInfo";
import { wsMTACardShipmentSchoolReceiveUpdateParmInfo } from "../shared/wsMTACardShipmentSchoolReceiveUpdateParmInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./mtastatus.component.html",
	styleUrls: ["./mtastatus.component.css"],
	providers: [ConfirmationService],
})
export class MTAStatusComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_mtacardmanager,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public MTACardShipmentID: number;

	public MTACardShipmentSchoolReceiveData: wsMTACardShipmentSchoolReceiveDataInfo;
	public lstReceiveStatusItems: wsMTACardShipmentSchoolReceiveStatusInfo[] = [];
	public SelectedReceiveStatus: wsMTACardShipmentSchoolReceiveStatusInfo;

	public ShipmentDT: Date = new Date();
	public ShipperTrackingNumber: string = "";
	public TotalBlocks: number = 0;
	public TotalCards: number = 0;
	public ShipComment: string = "";

	public ReceiveDT: Date = new Date();
	public ReceiveComment: string = "";

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.MTACardShipmentID = this.dialogConfig.data.MTACardShipmentID;
		this.TotalCards = this.dialogConfig.data.TotalCards;

		this.isBusy = true;
		this.dataService
			.MTACardShipmentSchoolReceiveDataGet(this.MTACardShipmentID)
			.subscribe((data) => this.MTACardShipmentSchoolReceiveDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolReceiveDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolReceiveDataGet_Complete(data: any) {
		this.MTACardShipmentSchoolReceiveData = data;

		this.ShipmentDT = new Date(this.MTACardShipmentSchoolReceiveData.ShipmentDT);
		this.ShipperTrackingNumber = this.MTACardShipmentSchoolReceiveData.ShipperTrackingNumber;
		this.TotalBlocks = this.MTACardShipmentSchoolReceiveData.TotalBlocks;
		this.ShipComment = this.MTACardShipmentSchoolReceiveData.ShipmentComment;

		this.lstReceiveStatusItems = this.MTACardShipmentSchoolReceiveData.ReceiveStatusItems;
		this.SelectedReceiveStatus = this.lstReceiveStatusItems[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		if (this.ReceiveDT == null || this.ReceiveDT.getTime() <= this.ShipmentDT.getTime()) {
			this.ErrorMessage = "Receive Date must be greater than Ship Date.";
		} else {
			this.ErrorMessage = "";

			let parms: wsMTACardShipmentSchoolReceiveUpdateParmInfo = {
				MTACardShipmentID: this.MTACardShipmentID,
				ReceivedBy_PersonID: this.UserPersonID,
				ReceivedDT: new Date(this.ReceiveDT).toLocaleString("en-US"),
				Received_MTACardShipmentStatusID: this.SelectedReceiveStatus.MTACardShipmentStatusID,
				ReceiveComment: this.ReceiveComment,
			};

			this.isBusy = true;
			this.dataService.MTACardShipmentSchoolReceiveUpdate(parms).subscribe((data) => this.MTACardShipmentSchoolReceiveUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTACardShipmentSchoolReceiveUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MTACardShipmentSchoolReceiveUpdate_Complete(data: any) {
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
